var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChat = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  fillRule: "evenodd"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M7.556 2.002c-3.592 0-6.503 2.773-6.503 6.193v1.181c0 2.768 2.356 5.012 5.263 5.012h.526v2.69l4.045-2.69h1.557c3.591 0 6.503-2.773 6.503-6.193s-2.911-6.193-6.503-6.193zM0 8.195C0 4.22 3.383 1 7.556 1h4.888C16.617 1 20 4.221 20 8.195s-3.383 7.195-7.556 7.195h-1.226L5.79 19v-3.63C2.548 15.114 0 12.528 0 9.375z",
  clipRule: "evenodd"
})));
export default SvgChat;